import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_SALON_REPORT_API} from '@app/reactQuery/apis/constants/rqSalonReportAPIConstants';

export const RQUseGetSalonReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_salon_report_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_SALON_REPORT_API,
        null,
        certificate,
        {divisionId: divisionId},
        signal,
      );
    },
    ...options,
  });
};
